module.exports = __webpack_public_path__ + "img/pay.e6687473.png";